// extracted by mini-css-extract-plugin
export default {"Page":"PageBase_Page__VUa8r","Page--overflow":"PageBase_Page--overflow__WCg8l"};